import React, { Component, Fragment } from "react";
import PropTypes from 'prop-types';
import { Divider, IconButton, Tooltip } from "@mui/material";
import Typography from "@mui/material/Typography";
import LoginMenu from "../../../../components/LoginMenu/LoginMenu";
import ReportsTableComponent from "./Chunks/ReportsTableComponent";
import FilterIcon from "@mui/icons-material/FilterList";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomizedSnackbar from "../../../../components/CustomizedSnackbar/CustomizedSnackbar";
import EditDeleteTableRecord from "../../../../components/EditDeleteTableRecord/EditDeleteTableRecord";
import ReportsFilter from './Chunks/ReportsFilter';
import { format } from 'date-fns';

class GradedDiscussionReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showTableFilter: false,
      admissionData: [],

      isLoginMenu: false,
      isReload: false,

      courseId: 0,
      coursesData: [],
      typeId: 1,

      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
    };
  }

  handleOpenSnackbar = (msg, severity) => {
    this.setState({
      isOpenSnackbar: true,
      snackbarMessage: msg,
      snackbarSeverity: severity,
    });
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      isOpenSnackbar: false,
    });
  };

  onHandleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    })
  }

  onClearFilters = () => {
    this.setState({
      courseId: 0,
      typeId: 1,
    })
  }

  getData = async () => {
    this.setState({
      isLoading: true,
    });
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C106CommonAcademicsGradedDiscussionsBoardStudentsView?type=${this.state.typeId}&courseId=${this.state.courseId}`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            this.setState({
              admissionData: json.DATA || [],
            });
            for (var i = 0; i < json.DATA.length; i++) {
              const id = json.DATA[i].id;
              const gdaId = json.DATA[i].gdaId;
              const dueDate = json.DATA[i].gdaDueDateWithoutConversion || new Date();
              const startDate = json.DATA[i].gdaStartDateWithoutConversion || new Date();
              const currenDate = format(new Date(), "MM-dd-yyyy");
              const dueDateCheck = new Date(dueDate).getTime() < new Date(currenDate).getTime() || json.DATA[i].isUploaded === 1 || new Date(startDate).getTime() > new Date(currenDate).getTime();
              json.DATA[i].action = (
                <EditDeleteTableRecord
                  recordId={id}
                  deleteRecord={this.DeleteData}
                  disableDeleteAction
                  hideDeleteAction
                  showViewAction={dueDateCheck}
                  hideEditAction={dueDateCheck}
                  editRecord={() => window.location.replace(`#/dashboard/graded-discussion/${gdaId}`)}
                  viewRecord={() => window.location.replace(`#/dashboard/graded-discussion/${gdaId}`)}
                />
              );
            }
          } else {
            this.handleOpenSnackbar(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE, "error");
          }
          console.log("getData", json);
        },
        (error) => {
          if (error.status === 401) {
            this.setState({
              isLoginMenu: true,
              isReload: true,
            });
          } else {
            this.handleOpenSnackbar(
              "Failed to fetch, Please try again later.",
              "error"
            );
            console.log(error);
          }
        }
      );
    this.setState({
      isLoading: false,
    });
  };

  DeleteData = async (event) => {
    event.preventDefault();
    const data = new FormData(event.target);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C34CommonAcademicsAssignmentsDelete`;
    await fetch(url, {
      method: "POST",
      body: data,
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("uclAdminToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {
            this.handleOpenSnackbar("Deleted", "success");
            this.getData();
          } else {
            this.handleOpenSnackbar(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE, "error");
          }
          console.log(json);
        },
        (error) => {
          if (error.status === 401) {
            this.setState({
              isLoginMenu: true,
              isReload: true,
            });
          } else {
            this.handleOpenSnackbar(
              "Failed to fetch, Please try again later.",
              "error"
            );
            console.log(error);
          }
        }
      );
  };

  getCoursesData = async () => {
    this.setState({
      isLoading: true,
    });
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/lms/C106CommonAcademicsCoursesStudentsView`;
    await fetch(url, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + localStorage.getItem("lmsToken"),
      }),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (json) => {
          if (json.CODE === 1) {

            if (json.DATA) {
              if (json.DATA.length > 0) {
                this.setState({
                  coursesData: json.DATA || [],
                });
              }
            }
          } else {
            this.handleOpenSnackbar(json.SYSTEM_MESSAGE + "\n" + json.USER_MESSAGE, "error");
          }
          console.log("getData", json);
        },
        (error) => {
          if (error.status === 401) {
            this.setState({
              isLoginMenu: true,
              isReload: true,
            });
          } else {
            this.handleOpenSnackbar(
              "Failed to fetch, Please try again later.",
              "error"
            );
            console.log(error);
          }
        }
      );
    this.setState({
      isLoading: false,
    });
  };

  handleToggleTableFilter = () => {
    this.setState({ showTableFilter: !this.state.showTableFilter });
  };

  componentDidMount() {
    this.props.setDrawerOpen(false);
    this.loadingData();
  }

  loadingData = async () => {
    await this.getCoursesData();
    await this.getData();
  }

  render() {

    const columns = [
      { name: "sectionLabel", title: "Section" },
      { name: "courseLabel", title: "Course" },
      { name: "gdaLabel", title: "Topic" },
      { name: "gdaTotalMarks", title: "Total\xa0Marks" },
      { name: "obtainedMarks", title: "Obtained\xa0Marks", getCellValue: row => (row.obtainedMarks ? row.obtainedMarks : ""), },
      { name: "percentage", title: "Percentage", getCellValue: row => (row.percentage ? Number(row.percentage).toFixed(2) + " %" : ""), },
      { name: "gdaStartDate", title: "Start\xa0Date" },
      { name: "gdaDueDate", title: "Due\xa0Date" },
      { name: "action", title: "Action" },
    ];

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <div
          style={{
            padding: 20
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              style={{
                color: "#1d5f98",
                fontWeight: 600,
                textTransform: "capitalize",
              }}
              variant="h5"
            >
              <Tooltip title="Back">
                <IconButton onClick={() => window.location.replace('#/dashboard')} size="large">
                  <ArrowBackIcon fontSize="small" color="primary" />
                </IconButton>
              </Tooltip>
              Graded Discussion Board Reports
            </Typography>
            <div style={{ float: "right" }}>
              <Tooltip title="Table Filter">
                <IconButton
                  style={{ marginLeft: "-10px" }}
                  onClick={this.handleToggleTableFilter}
                  size="large">
                  <FilterIcon fontSize="default" color="primary" />
                </IconButton>
              </Tooltip>
            </div>
          </div>
          <Divider
            style={{
              backgroundColor: "rgb(58, 127, 187)",
              opacity: "0.3",
            }}
          />
          <ReportsFilter isLoading={this.state.isLoading} values={this.state} getData={() => this.getData()}
            onHandleChange={this.onHandleChange} onClearFilters={() => this.onClearFilters()} />
          <div style={{ marginTop: 20 }} />
          <ReportsTableComponent
            data={this.state.admissionData}
            columns={columns}
            showFilter={this.state.showTableFilter}
          />
          <CustomizedSnackbar
            isOpen={this.state.isOpenSnackbar}
            message={this.state.snackbarMessage}
            severity={this.state.snackbarSeverity}
            handleCloseSnackbar={() => this.handleCloseSnackbar()}
          />
        </div>
      </Fragment>
    );
  }
}

GradedDiscussionReports.propTypes = {
  setDrawerOpen: PropTypes.func
}

GradedDiscussionReports.defaultProps = {
  setDrawerOpen: fn => fn
}

export default GradedDiscussionReports;
